import { authSlice } from "./reducer";

export const {
  anonymousSignInSuccess,
  logInSuccess,
  signOutRequest,
  signOutSuccess,
  synchronizeUserSuccess,
  updateDevice,
  updateUserSuccess
} = authSlice.actions;
